import { render, staticRenderFns } from "./zyzd.vue?vue&type=template&id=24feb844&scoped=true"
import script from "./zyzd.vue?vue&type=script&lang=js"
export * from "./zyzd.vue?vue&type=script&lang=js"
import style0 from "./zyzd.vue?vue&type=style&index=0&id=24feb844&prod&lang=less&scoped=scoped"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24feb844",
  null
  
)

export default component.exports